export { default } from './SideShoppingCart';
